import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Box, Text } from 'rebass/styled-components';

import moment from 'moment';
import { trackEvent } from '../../../helpers/analytics';
import { activeNetworkSelector } from '../../../redux/selectors';
import { useRefreshSharedListMutation } from '../../../services/contacts';
import { contactsV2Api } from '../../../services/contactsV2';

export const useRerunAutoUpdate = (sharedList) => {
  const [refreshSharedList, { isLoading: isLoadingRefresh }] = useRefreshSharedListMutation();
  const activeNetwork = useSelector(activeNetworkSelector);
  const dispatch = useDispatch();

  const onClickAutoUpdate = async () => {
    const { error } = await refreshSharedList({ sharedListId: sharedList.id });

    if (!error) {
      dispatch(contactsV2Api.util.invalidateTags([{ type: 'contacts', id: sharedList.id }]));

      toast(
        <Box>
          <Text fontSize="14px">Auto-update in progress</Text>
          <Text fontSize="14px" mt="4px" fontWeight="body">
            It may take a few minutes.
          </Text>
        </Box>,
        { icon: 'success', id: 'shared-lists-refresh' },
      );

      trackEvent('contacts:list:force_auto_update', {
        collectionId: activeNetwork.id,
        listId: sharedList.id,
      });
    }
  };

  return {
    onClickAutoUpdate,
    isLoadingRefresh,
    lastUpdated: sharedList?.smartSharedList?.populatedOn
      ? moment(sharedList?.smartSharedList?.populatedOn).fromNow()
      : null,
  };
};
